module.exports = __webpack_public_path__ + "img/food_pizza.9c6bbefe.png";